import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createPlace } from '../../api/place.ts';
import { CreatePlaceRequest } from '../../api/requests/place-request.ts';

export default function useCreatePlace(): UseMutationResult<
  Awaited<ReturnType<typeof createPlace>>,
  Error,
  CreatePlaceRequest
> {
  return useMutation({
    mutationFn: createPlace,
  });
}
